export default "__VITE_ASSET__DQdAVm0a__"